// actions/house.ts — M1
import { ROOF_COLORS, type RoofColor } from '@whiskerton/content';
import { defineAction, type Ok } from '../define';
import { g } from '../guard';
import type { DoorSetting, PendingUpgrade } from '../../types/resident';
declare module '../registry' {
  interface ActionMap {
    'loan.pay': { req: { amount: number }; res: { loan: number; paidOff: boolean } };
    'house.upgrade': { req: { roof: RoofColor | null }; res: { pending: PendingUpgrade } };   // revision 10 (D-04): a kit roof colour
    'house.door': { req: { door: DoorSetting }; res: Ok };
  }
}
export const loanPay = defineAction('loan.pay', g.obj({ amount: g.int(1, 1e9) }));
export const houseUpgrade = defineAction('house.upgrade', g.obj({ roof: g.nullable(g.lit<RoofColor>(...ROOF_COLORS)) }));
export const houseDoor = defineAction('house.door', g.obj({ door: g.lit<DoorSetting>('open', 'home', 'locked') }));
